import React from "react";

import EventCalendar from "./EventCalendar";

import PageTitle from "../../../layouts/PageTitle";

const Calendar = () => {
  return (
    <div className="h-80">
      <PageTitle
        activeMenu="Calendar"
        motherMenu="App"
        activeMenuLink={"agents"}
        motherMenuLink={"agents"}
      />

      <EventCalendar />
    </div>
  );
};

export default Calendar;
